import { useMutation, useQueryClient } from 'react-query';
import { enviarOktonBank } from '../oktonbank';

// Cadastra um título já liquidado na Conta. É o movimento que apareceu no
// extrato e nunca foi lançado no ERP: tarifa, IOF, juros, rendimento.
// Um cheque que liquida o lançamento. Não tem código: só passa a existir no
// banco quando o lançamento é gravado, no mesmo commit.
export interface ChequeLancamento {
  valor: string;
  documento: string;
  banco: string;
  emitente: string;
  cpfcnpj: string;
  vencimento: string;
  observacao: string;
}

export interface NovoLancamentoFinanceiro {
  conta: string;
  tipo: string;
  data: string;
  valor: string;
  documento?: string;
  observacao?: string;
  cliente?: string;
  centrocusto?: string;
  departamento?: string;
  direcionador?: string;
  // Instrumento em que o título é baixado, entre as Moedas da Conta. Em
  // branco, a Moeda do próprio banco.
  moeda?: string;
  // Os cheques, em JSON, quando a Moeda é de Cheque de Terceiro.
  cheques?: string;
}

function invalidarLancamentos(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries('lancamentos-financeiros');
  queryClient.invalidateQueries('monitor-bancario-resumo');
  queryClient.invalidateQueries('dashboard');
  // A conciliação lista os mesmos títulos.
  queryClient.invalidateQueries('conciliacoes');
}

export function useCreateLancamentoFinanceiro() {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: NovoLancamentoFinanceiro) =>
      enviarOktonBank('OBFinanceiro', 'cadastrar', { ...payload }),
    {
      onSuccess: () => invalidarLancamentos(queryClient),
    },
  );
}

// Só exclui título nascido no Financeiro e ainda não conciliado: o back
// recusa o que veio de Venda, Compra ou Renegociação, porque apagar aqui
// deixaria o movimento de origem no IFLEX sem o título correspondente.
export function useDeleteLancamentoFinanceiro() {
  const queryClient = useQueryClient();

  return useMutation(
    (id: string) =>
      enviarOktonBank('OBFinanceiro', 'excluir', { financeiro: id }),
    { onSuccess: () => invalidarLancamentos(queryClient) },
  );
}
